import data from './categories.json';
import { Category } from './types';

interface CategoriesFile {
  categories: Category[];
}

export const CATEGORIES: Category[] = (data as CategoriesFile).categories;

export function getCategory(categoryId: string): Category | undefined {
  return CATEGORIES.find((category) => category.id === categoryId);
}

export function pickPuzzle(
  categoryId: string,
  usedPuzzles: string[],
  random: () => number = Math.random
): { phrase: string; categoryName: string } {
  const category = getCategory(categoryId);
  if (!category) {
    throw new Error(`Unknown category: ${categoryId}`);
  }

  const unused = category.puzzles.filter((puzzle) => !usedPuzzles.includes(puzzle));
  const pool = unused.length > 0 ? unused : category.puzzles;
  const phrase = pool[Math.floor(random() * pool.length)];
  return { phrase, categoryName: category.name };
}
